import * as React from "react";

function SvgStitch(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 186.9 186.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#FFD201"
        d="M186.9 73.8V0H0v100h128.5v13.1H0v73.8h186.9v-100H58.4V73.8h128.5zm-93.5 93.9c-5.1 0-9.2-4.1-9.2-9.2s4.1-9.2 9.2-9.2 9.2 4.1 9.2 9.2-4.1 9.2-9.2 9.2zm41.4-28.5H52l4-13.1h75.2l3.6 13.1zm-41.4-120c5.1 0 9.2 4.1 9.2 9.2s-4.1 9.2-9.2 9.2-9.2-4.1-9.2-9.2 4.1-9.2 9.2-9.2zM55.9 60.7l-4-13.1h82.9l-3.7 13.1H55.9z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgStitch);
